import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid, useTheme } from "@mui/material";
import CustomButton from "../../components/CustomButton";
import { CustomSectionHeader } from "../../components/CustomSectionHeader";
import { STEPS_REGISTER } from "../../utils/util";
import { cached } from "../../utils/cache";
import { getPackageInfo, getPackageSeleted, isVumaReachPackage, setPackageInfo } from "../../utils/commons";
import wsclients from "../../services/wsclients";
import CustomLoading from "../../components/CustomLoading";

export default function ChooseBillingDate(props) {
    const { t } = useTranslation();
    const [showLoading, setShowLoading] = useState(false);
    const [billingDay, setBillingDay] = useState('NON_RECURRING');
    const { palette } = useTheme();
    const packageInfo = getPackageInfo();
    const package_selected = getPackageSeleted() ? getPackageSeleted() : null;

    useEffect(() => {
        getProductDetail();
    },[billingDay]);

    const getProductDetail = async () => {
        if (!isVumaReachPackage(packageInfo?.product_type)) return false;
        setShowLoading(true)
        try {
            let _product = {
                ...packageInfo, 
                image_url: package_selected && package_selected.image_url, 
                product_type: package_selected.product_type,
                product_type_code: package_selected && package_selected.product_type_code,
                code: package_selected && package_selected.code,
            }
            var result = await wsclients.lab4services.getDetailProduct(package_selected.code, billingDay == 'RECURRING' ? true : false);
            console.log("result getDetailProduct===", result);
            if (result.code == 'OK' && result.data) {
                _product = { ..._product, ...result.data };
                if (result.data.pricing && result.data.pricing.price) {
                    if (billingDay == 'NON_RECURRING') {
                        _product.price_o = result.data.pricing.price;
                        _product.price = parseFloat(result.data.pricing.price);
                    }
                    else {
                        _product.price_r = result.data.pricing.price;
                        _product.price = parseFloat(result.data.pricing.price);
                    }
                }
                setPackageInfo(_product)
            }
        } catch (error) {
            console.log("AAAA getProductDetail error: ", error)
        }
        setShowLoading(false);
    }

    const onContinue = () => {
        cached.setBillinginfo({ is_recurring: billingDay == 'RECURRING' ? true : false, date: null });
        props.stepsControl.goToStepByName(STEPS_REGISTER.billing_date);
    }

    return (<>
        <Grid item xs={12}>
            <CustomSectionHeader
                title={t('choose_billing_date')}
                subtitle={t('billing_date_desc')}
                stepsControl={props.stepsControl}
                virtualStep={STEPS_REGISTER.registration} />
            <Grid item xs={12} my={2} mt={4} container justifyContent={'center'} gap={2}>
                <CustomButton variant={'outlined'} style={{
                    borderColor: billingDay == 'NON_RECURRING' ? palette.primary.main : palette.border.input, 
                    color: billingDay == 'NON_RECURRING' ? palette.primary.main : palette.common.black,
                    }} 
                    onClick={() => setBillingDay('NON_RECURRING')}
                >{t('prepaid_non_recurring')}</CustomButton>
                <CustomButton variant={'outlined'} style={{ 
                    borderColor: billingDay == 'RECURRING' ? palette.primary.main : palette.border.input,
                    color: billingDay == 'RECURRING' ? palette.primary.main : palette.common.black,

                    }} onClick={() => setBillingDay('RECURRING')}>{t('monthly_recurring')}</CustomButton>
            </Grid>
            <Grid item xs={12} my={2} mt={4} container justifyContent={'center'}>
                <CustomButton variant={'contained'} onClick={() => onContinue()}>{t('btn_confirm_continue')}</CustomButton>
            </Grid>
        </Grid>
        {showLoading && <CustomLoading open={showLoading}/>}
        </>
    )
}